import { useOrderSocket } from "../hooks/useOrderSocket";
import { invalidatePublic, invalidateRestaurant } from "../lib/dataCache";

/* App-level cache invalidation: canonical menu/settings events must drop the cached PUBLIC
   payloads no matter which page is mounted. Without this, pausing a restaurant while the
   customer is on its menu would leave the home card showing OTVORENO from memory.
   Only the affected restaurant's entries are dropped — never every restaurant. */
export default function CacheInvalidator() {
  useOrderSocket((msg) => {
    if (!["menu_update", "product_update", "settings_update"].includes(msg.type)) return;
    const rid = msg.restaurant_id || msg.product?.restaurant_id;
    if (!rid) return;
    invalidatePublic("/restaurants");     // public card state: open/closed, promo, coins
    invalidateRestaurant(rid);            // that restaurant's detail + menu
  });
  return null;
}
